'use client';

import { useState } from 'react';
import { Repeat } from 'lucide-react';
import { Button } from '@/atoms/Button/Button';
import { useRequireAuth } from '@/hooks/useRequireAuth/useRequireAuth';
import { cn } from '@/libs/utils/utils';
import { DialogNewPost } from '@/organisms/DialogNewPost/DialogNewPost';
import { RESOURCE_ACTION_BUTTON_CLASS_NAME } from './ResourceActions.constants';

/**
 * "Post about this": opens the new-post composer with the external resource's link in the text,
 * where it shows as its card. Signed out, it asks to sign in.
 */
export function ResourcePostButton({ uri }: { uri: string }) {
  const { requireAuth } = useRequireAuth();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant="ghost"
        size="sm"
        className={cn(RESOURCE_ACTION_BUTTON_CLASS_NAME, 'w-10')}
        aria-label="Post about this"
        title="Post about this"
        onClick={() => requireAuth(() => setOpen(true))}
        data-testid="resource-post-button"
      >
        <Repeat aria-hidden="true" />
      </Button>
      {open && <DialogNewPost open={open} onOpenChangeAction={setOpen} initialContent={uri} />}
    </>
  );
}
